module.exports = __webpack_public_path__ + "static/media/behindTheScenes.7a50a108.png";